// extracted by mini-css-extract-plugin
module.exports = {"passwordSettings":"UserSettingsPassword__passwordSettings"};